export const tabConfig = {
  users: {
    value: 'users',
    label: 'Benutzer',
  },
  organisations: {
    value: 'organisations',
    label: 'Organisationen',
  },
  tokenSpend: {
    value: 'tokenSpend',
    label: 'KI-Nutzung',
  },
}
